// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uU","title":"uV","notSelected":"uW","duration":"uX","image":"uY","infoWrapper":"uZ","description":"u0"};